/**
 * PrivateRoute.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import React from "react";
import { Route, Redirect } from "react-router-dom";

import routes from "../constants/routes";

/**
 * Redirects users to the login page if they are not logged in
 *
 * @param {*} param0
 */
/* eslint-disable react/prop-types */
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      rest.isUserAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: routes.LOGIN, state: { from: props.location } }}
        />
      )
    }
  />
);

export default PrivateRoute;
